export const TO_NEXT_LEVEL = 'TO_NEXT_LEVEL';
export const RESET_LEVEL = 'RESET_LEVEL';

export const NEXT_ANSWER = 'NEXT_ANSWER';
export const RESET_ANSWER = 'RESET_ANSWER'
